export type NotificationType = 'success' | 'info' | 'warning' | 'error';

export interface INotification {
  id: string;
  message: string;
  type: NotificationType;
}

type NotificationListener = (notifications: INotification[]) => void;

/**
 * OOP Singleton Service for Managing Toast Alerts
 */
export class NotificationService {
  private static instance: NotificationService;
  private notifications: INotification[] = [];
  private listeners: NotificationListener[] = [];

  private constructor() {}

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  public subscribe(listener: NotificationListener): () => void {
    this.listeners.push(listener);
    listener(this.notifications);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  private notify(): void {
    this.listeners.forEach(l => l([...this.notifications]));
  }

  public show(message: string, type: NotificationType = 'success', durationMs: number = 4000): void {
    const id = 'toast-' + Math.random().toString(36).substring(2, 9);
    const notification: INotification = { id, message, type };

    this.notifications.push(notification);
    this.notify();

    setTimeout(() => {
      this.dismiss(id);
    }, durationMs);
  }

  public dismiss(id: string): void {
    this.notifications = this.notifications.filter(n => n.id !== id);
    this.notify();
  }
}
